import { func, shape, bool, object } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { get } from 'ravenjs/utils/lodash';

import { MODALS } from 'constants/modals';
import { actions as uiActions, selectors as uiSelectors } from 'modules/ui';
import Modal from '../Modal';

const WelcomeEmailEditorModal = props => {
    const { closeModal, modal } = props;
    const open = get(modal, 'open', false);
    const content = get(modal, 'data.content');
    const title = get(modal, 'data.title', '');

    const onClickCloseIcon = () => {
        closeModal(MODALS.WELCOME_EMAIL_EDITOR);
    };

    return (
        <Modal
            id={MODALS.WELCOME_EMAIL_EDITOR}
            content={content}
            hideActions
            modalHeaderProps={{
                removeBorderBottom: true,
            }}
            modalBodyProps={{
                padding: '0 12px',
            }}
            onClickCloseIcon={onClickCloseIcon}
            open={open}
            showFullView
            title={title}
        />
    );
};

WelcomeEmailEditorModal.propTypes = {
    closeModal: func.isRequired,
    modal: shape({
        open: bool,
        data: object,
    }).isRequired,
};

const mapStateToProps = createStructuredSelector({
    modal: uiSelectors.getModalById(MODALS.WELCOME_EMAIL_EDITOR),
});
const mapDispatchToProps = {
    closeModal: uiActions.closeModal,
};

export { WelcomeEmailEditorModal as WelcomeEmailEditorModalUnwrapped };
export default connect(mapStateToProps, mapDispatchToProps)(WelcomeEmailEditorModal);
